module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "supplier-sidebar",
    attrs: {
      "id": "page-content"
    }
  }, [_c('div', {
    staticClass: "component-padding",
    attrs: {
      "id": "myproducts"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "products-list"
  }, _vm._l((9), function(n) {
    return _c('div', {
      staticClass: "col-md-4 product-item"
    }, [_c('img', {
      attrs: {
        "src": "static/images/j.jpeg"
      }
    }), _vm._v(" "), _vm._m(1, true), _vm._v(" "), _vm._m(2, true), _vm._v(" "), _c('p', {
      staticClass: "text-justify"
    }, [_vm._v("Chase red laser dot eat half my food and ask for more. Make muffins if it fits, i sits meow meow chase red.")]), _vm._v(" "), _c('p', [_vm._v("Status: Approved")])])
  })), _vm._v(" "), _vm._m(3)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "myproducts-options"
    }
  }, [_c('h1', [_vm._v("My Products")]), _vm._v(" "), _c('div', [_c('input', {
    attrs: {
      "type": "text",
      "placeholder": "Search my Products"
    }
  }), _vm._v(" "), _c('select', {
    attrs: {
      "name": "francis"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("All Products")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Wall Sconces")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Chandeliers")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Pendants")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Undercabinet")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Ceiling")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Desk, Floor & Table Lamps")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Track")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Architectural")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Recessed")])]), _vm._v(" "), _c('select', {
    attrs: {
      "name": "fabrianne"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("All Status")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Unread")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Approved")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Rejected")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Product Code: "), _c('strong', [_vm._v("6SGHA14")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Price: "), _c('strong', [_vm._v("Php 140.00")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cta-section-2",
    staticStyle: {
      "margin-top": "40px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Load more products")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-93172780"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SupplierProducts.vue
// module id = 160
// module chunks = 0